import { COVERAGE_ID } from 'scenes/common/api/quote/marshaller/ids';
import { WireCoverageType } from 'scenes/common/api/quote/types';
import { Excess } from 'scenes/common/types';
import { getCoverType } from 'scenes/home/selectors';
import { HomeFunnelState, SpecifiedContent } from 'scenes/home/types';
import { toWireCoverType } from 'scenes/common/api/quote/marshaller/coverage';

import { toWireSumsInsured } from './sumInsured';
import { toWireItems } from './coverageItem';
import { WireHomeCoverageRequest } from '../types';
import { toWireOptions } from './option';

export const toWireCoverages = (
  state: HomeFunnelState,
  excesses?: Excess[],
  extras?: string[],
  specifiedContents?: SpecifiedContent[],
  unspecifiedPortablesValue?: string
): WireHomeCoverageRequest[] => [
  {
    id: COVERAGE_ID,
    name: toWireCoverType(getCoverType(state)),
    type: WireCoverageType.Standard,
    excessRefIds:
      excesses?.filter((excess) => excess?.id).map(({ id }) => id) || [],
    sumInsureds: toWireSumsInsured(state),
    options: toWireOptions(state, extras),
    items: toWireItems(state, specifiedContents, unspecifiedPortablesValue),
  },
];

export const coverageRefIds = (state: HomeFunnelState): string[] => [
  ...toWireCoverages(state).map((coverage) => coverage.id),
];
